import { c as _c } from "react/compiler-runtime";
import type { Driver } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { InfoTooltip } from '@cc-shopping/ui/composites/InfoTooltip';
import { Box, Typography } from '@mui/material';
import type React from 'react';
import { DRIVERS_WITH_BONUS_TYPES } from './constants';
export const SmallQuestionMark = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span aria-hidden="true" className="mask-icon mask-icon-help-outline" style={{
      width: "13px",
      height: "13px",
      backgroundColor: "#9E9E9E"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
interface DriverCardsProps {
  driver?: Driver;
  driverDetails?: string;
  tooltip?: string;
  bonusType?: string;
  displayTooltip?: boolean;
  displayType?: boolean;
}
const DriverCard: React.FC<DriverCardsProps> = t0 => {
  const $ = _c(27);
  let {
    driver,
    driverDetails,
    tooltip,
    bonusType,
    displayTooltip,
    displayType
  } = t0;
  if (!driver) {
    return null;
  }
  let t1;
  if ($[0] !== driver) {
    t1 = DRIVERS_WITH_BONUS_TYPES.includes(driver);
    $[0] = driver;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showBonusType = t1;
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[2] !== bonusType || $[3] !== displayTooltip || $[4] !== displayType || $[5] !== driverDetails || $[6] !== showBonusType || $[7] !== tooltip) {
    let bonusTypeText = bonusType?.toLowerCase() ?? "";
    if (bonusTypeText?.includes("cash")) {
      bonusTypeText = "cashback";
    }
    if (driverDetails && driverDetails.toLowerCase().includes("cashback match")) {
      displayType = false;
    }
    T0 = Box;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        display: "flex",
        flexDirection: "column",
        padding: "1rem 0"
      };
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    let t5;
    if ($[14] !== driverDetails) {
      t5 = driverDetails && <Typography component="span" sx={{
        marginRight: "2px"
      }}>{driverDetails}</Typography>;
      $[14] = driverDetails;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== displayTooltip || $[17] !== tooltip) {
      t6 = tooltip && displayTooltip && <InfoTooltip text={tooltip} ariaLabel="tooltip" trigger={<SmallQuestionMark />} />;
      $[16] = displayTooltip;
      $[17] = tooltip;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    if ($[19] !== t5 || $[20] !== t6) {
      t3 = <Box>{t5}{t6}</Box>;
      $[19] = t5;
      $[20] = t6;
      $[21] = t3;
    } else {
      t3 = $[21];
    }
    t4 = showBonusType && displayType && <Typography sx={{
      fontSize: "0.8rem"
    }}>{bonusTypeText.charAt(0).toUpperCase() + bonusTypeText.slice(1)}</Typography>;
    $[2] = bonusType;
    $[3] = displayTooltip;
    $[4] = displayType;
    $[5] = driverDetails;
    $[6] = showBonusType;
    $[7] = tooltip;
    $[8] = T0;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = displayType;
  } else {
    T0 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    displayType = $[12];
  }
  let t5;
  if ($[22] !== T0 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4) {
    t5 = <T0 sx={t2}>{t3}{t4}</T0>;
    $[22] = T0;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
};
export default DriverCard;